import { routerReducer as routing } from "react-router-redux";
import { reducer as app } from "@redux/app";
import { reducer as payments } from "@redux/payments";
import { reducer as account } from "@redux/account";
import { reducer as officers } from "@redux/officers";
import { reducer as admin } from "@redux/admin";
import { reducer as reports } from "@redux/reports";

export default {
	routing,
	app,
	payments,
	account,
	admin,
	officers,
	reports,
};
